import { Container, Typography, Box, Paper } from '@mui/material'

const About = () => {
  return (
    <Container maxWidth="md" sx={{ py: 8 }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography variant="h3" component="h1" gutterBottom fontWeight="bold">
          About Getmocksy
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h5" gutterBottom color="primary">
            Technology Stack
          </Typography>
          <Typography variant="body1" paragraph>
            This application is built using modern web technologies:
          </Typography>
          <ul>
            <li>
              <Typography variant="body1">
                <strong>React 18</strong> - A JavaScript library for building user interfaces
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                <strong>Vite</strong> - Next generation frontend tooling
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                <strong>Material-UI (MUI)</strong> - React component library for faster development
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                <strong>React Router</strong> - Declarative routing for React applications
              </Typography>
            </li>
          </ul>
        </Box>

        <Box sx={{ mt: 4 }}>
          <Typography variant="h5" gutterBottom color="primary">
            Features
          </Typography>
          <Typography variant="body1" paragraph>
            - Dark/Light theme toggle
          </Typography>
          <Typography variant="body1" paragraph>
            - Responsive design
          </Typography>
          <Typography variant="body1" paragraph>
            - Custom hooks and utilities
          </Typography>
          <Typography variant="body1" paragraph>
            - API client service
          </Typography>
        </Box>
      </Paper>
    </Container>
  )
}

export default About
